export default "__VITE_ASSET__BibwqkSb__"